import { useDeviceContext } from "src/context/device-context";
import { useLoaderData } from "react-router";
import useLoginPopup from "src/hooks/useLoginPopup";
import HotelSearchForm from "src/components/features/search-form/SearchForm/HotelSearchForm";
import { CheapHotelDeals } from "src/components/features/home/CheapHotelDeals/CheapHotelDeals";
import { Hero } from "src/components/features/home/Hero/Hero";

function Hotels() {
  const { isMobile } = useDeviceContext();
  const { cheapHotels } = useLoaderData();
  useLoginPopup();

  return (
    <main id="tickets-home-page" className={`hotels-page ${isMobile ? "mobile" : "desktop"}`}>
      <div className="home-content white">
        {isMobile && <Hero />}
        <HotelSearchForm />
        <CheapHotelDeals data={cheapHotels.data} />
      </div>
      <div className="home-content off-white"></div>
    </main>
  );
}

export default Hotels;
